// QR codes for the ProProxyUI VPN profiles (My Proxies). WireGuard's QR code is the profile itself (the app scans
// it). OpenVPN Connect cannot scan one, so its QR code is a 10-minute link that downloads the .ovpn on the phone.
import QRCode from 'qrcode';
import { useProxyStore } from '@/stores';

const opts = { margin: 1, width: 320, errorCorrectionLevel: 'M' };

export async function wgQr(uuid) {
    const f = await useProxyStore().vpnFile(uuid, 'wg');
    return f && f.content ? QRCode.toDataURL(f.content, opts) : null;
}

export const linkQr = (url) => (url ? QRCode.toDataURL(url, opts) : null);   // any download link (ProxySmart OpenVPN)

export async function ovpnQr(uuid) {
    const r = await useProxyStore().vpnQrLink(uuid);
    return r && r.url ? QRCode.toDataURL(r.url, opts) : null;
}
